const stringToFloat = (numString, opts = {}) => {
	let config = { decimalChar: ',', ...opts }
	let result = false;
	let type = typeof numString;
	if(type === "string") {
		let delimiterRegex = new RegExp(`[${config.decimalChar === ',' ? '.' : ','}]`, 'g')
		let decimalRegex = new RegExp(`[${config.decimalChar}]`, 'g')
		result = parseFloat(numString.replace(delimiterRegex, '').replace(decimalRegex, '.'));
	}
	else if(type === "number") {
		result = numString;
	}
	if(isNaN(result)){
		result = false;
	}

	return result;
}

export default stringToFloat